import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateSupplier } from "../../api/apiSuppliers";
import toast from "react-hot-toast";

const useUpdateSupplier = () => {
    const queryClient = useQueryClient();

    const { mutate: updateSupplierMutate, isPending } = useMutation({
        mutationFn: ({ req, id }) => updateSupplier(req, id),
        onSuccess: (res) => {
            toast.success(res.message || "Supplier updated successfully");
            queryClient.invalidateQueries({ queryKey: ["suppliers"] });
            queryClient.invalidateQueries({ queryKey: ["supplier"] });
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to update supplier");
        },
    });

    return { updateSupplierMutate, isPending };
};

export default useUpdateSupplier;
